import css from './index.module.scss';
import TOU from './icons/TOU';
import SelfPower from './icons/SelfPower';
import Coupon from './icons/Coupon';
import { useGlobal } from '@/utils/useGlobal';

let scene: any = null,
    sceneTextEnterI: any = null,
    sceneTextLeaveI: any = null;
export default function I() {
    const { useLang, useRouter, useEffect, useState, useRef, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('smart_home_panel_2.launch.detail');
    const [videoScene, setVideoScene] = useState('day');
    const [num, setNum] = useState(30);
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (sceneTextEnterI) {
                    AniContainer.removeScene(sceneTextEnterI);
                    sceneTextEnterI = null;
                }
                if (sceneTextLeaveI) {
                    AniContainer.removeScene(sceneTextLeaveI);
                    sceneTextLeaveI = null;
                }

                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                sceneTextEnterI = AniContainer.create({
                    triggerElement: '.shp2-detail-I .text-info',
                    triggerHook: 1,
                    offset: startH,
                    duration: 200,
                    onEnter: () => setTextEnter(true),
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (sceneTextEnterI) {
                    AniContainer.removeScene(sceneTextEnterI);
                    sceneTextEnterI = null;
                }
                if (sceneTextLeaveI) {
                    AniContainer.removeScene(sceneTextLeaveI);
                    sceneTextLeaveI = null;
                }

                //window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            if (scene) AniContainer.removeScene(scene);
            const resizeAni = () => {
                if (window?.innerWidth > 1024) {
                    scene = AniContainer.create({
                        asyncFromTo: [
                            ['.shp2-detail-I .box-1 .box-ani', { opacity: 0 }, { opacity: 1 }, 0.5],
                            ['.shp2-detail-I .box-1 .box-ani', { opacity: 1, y: 0, scale: 1 }, { opacity: 0, y: -150, scale: 0.75 }, 0.25],
                            ['.shp2-detail-I .box-2 .box-ani', { opacity: 0, y: 180 }, { opacity: 1, y: 0 }, 0.5],
                            ['.shp2-detail-I .box-2 .box-ani', { opacity: 1, y: 0, scale: 1 }, { opacity: 0, y: -150, scale: 0.75 }, 0.25],
                            ['.shp2-detail-I .box-3 .box-ani', { opacity: 0, y: 180 }, { opacity: 1, y: 0 }, 0.5],
                        ],
                        asyncTimeLine: [0, 1, 1.25, 2.25, 2.5],
                        triggerElement: '.shp2-detail-I',
                        triggerHook: 1,
                        offset: '50%',
                        duration: '300%',
                    });
                }
            };
            const video2 = document.querySelector('.shp2-detail-I .box-2 .video') as HTMLVideoElement;
            const video3 = document.querySelector('.shp2-detail-I .box-3 .video') as HTMLVideoElement;
            const video2Process = () => {
                if (video2) {
                    const rate = video2.currentTime / video2.duration;
                    if (rate >= 0.67 || rate < 0.33) {
                        return setVideoScene('day');
                    }
                    return setVideoScene('night');
                }
            };
            const video3Process = () => {
                if (video3) {
                    const rate = video3.currentTime / video3.duration;
                    setNum(30 - Math.round(30 * rate));
                }
            };
            resizeAni();
            video2Process();
            // window.addEventListener('resize', resizeAni);
            video2.addEventListener('timeupdate', video2Process);
            video3.addEventListener('timeupdate', video3Process);
            return () => {
                if (scene) AniContainer.removeScene(scene);
                // window.removeEventListener('resize', resizeAni);
                video2.removeEventListener('timeupdate', video2Process);
                video3.removeEventListener('timeupdate', video3Process);
            };
        }
    }, []);

    return (
        <section className={`shp2-detail-I shp2-detail-section ${css['shp2-detail-I']}`}>
            <div className="sticky-box">
                <div className={`text-info ${textEnter ? 'enter' : ''}`}>
                    <p className="subtitle">{t('secI_subtitle')}</p>
                    <h2 className="title">{t('secI_title')}</h2>
                    <p className="desc">
                        {t.rich('secI_desc', {
                            w: (text: string) => <span className="white">{text}</span>,
                        })}
                    </p>
                </div>
                <div className="flow-box">
                    <div className="box-1">
                        <div className="box-ani">
                            <p className="box1-text">
                                <span className="text">{t('secI_box1_text1')}</span>
                                <span className="text">{t('secI_box1_text2')}</span>
                            </p>
                            <div className="box-video">
                                <video
                                    src={'/responsive/video/smart-home-panel-2/launch/9_1.mp4'}
                                    className="box1-video video"
                                    width="100%"
                                    height="100%"
                                    muted
                                    autoPlay
                                    loop
                                    playsInline
                                    preload="auto"
                                    aria-label={t('secI_title')}
                                    poster="/responsive/picture/smart-home-panel-2/launch/9_1.png"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="box-2">
                        <div className="box-ani">
                            <div className="box-video">
                                <video
                                    src={'/responsive/video/smart-home-panel-2/launch/9_2.mp4'}
                                    className="box2-video video"
                                    width="100%"
                                    height="100%"
                                    muted
                                    autoPlay
                                    loop
                                    playsInline
                                    preload="auto"
                                    aria-label={t('secI_box2_title')}
                                    poster="/responsive/picture/smart-home-panel-2/launch/9_2.png"
                                />
                                <span className={`float-text on ${videoScene === 'day' ? 'active' : ''}`}>
                                    <span className="peak">{t('secI_box2_peak')}</span>
                                </span>
                                <span className={`float-text off ${videoScene === 'night' ? 'active' : ''}`}>
                                    <span className="offpeak">{t('secI_box2_offpeak')}</span>
                                </span>
                            </div>
                            <div className="box-info">
                                <div className="title-box">
                                    <TOU />
                                    <span className="box-title">{t('secI_box2_title')}</span>
                                </div>
                                <p className="box-desc">{t('secI_box2_desc')}</p>
                            </div>
                        </div>
                    </div>
                    <div className="box-3">
                        <div className="box-ani">
                            <div className="box-video">
                                <video
                                    src={'/responsive/video/smart-home-panel-2/launch/9_3.mp4'}
                                    className="box3-video video"
                                    width="100%"
                                    height="100%"
                                    muted
                                    autoPlay
                                    loop
                                    playsInline
                                    preload="auto"
                                    aria-label={t('secI_box3_title')}
                                    poster="/responsive/picture/smart-home-panel-2/launch/9_3.png"
                                />
                                <div className="video-coupon">
                                    <Coupon />
                                    <span className="money">
                                        {t('secI_box2_currency')}
                                        {num}
                                    </span>
                                </div>
                            </div>
                            <div className="box-info">
                                <div className="title-box">
                                    <SelfPower />
                                    <span className="box-title">{t('secI_box3_title')}</span>
                                </div>
                                <p className="box-desc">{t('secI_box3_desc')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
